import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  /** Reduce horizontal padding (used inside detail pages that already provide outer padding). */
  flush?: boolean;
}

/**
 * Standard responsive page container.
 *
 * Mobile (<md): px-4 py-4 space-y-4
 * Desktop (md+): px-6 py-6 space-y-6
 *
 * Always full-width with overflow-x guards so children can't blow the viewport on phones.
 */
export function PageContainer({ children, className, flush = false }: PageContainerProps) {
  return (
    <div className="bg-background w-full min-w-0 max-w-full overflow-x-hidden">
      <div
        className={cn(
          "w-full min-w-0 max-w-full",
          flush ? "py-4 md:py-6" : "px-4 py-4 md:px-6 md:py-6",
          "space-y-4 md:space-y-6",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default PageContainer;
